export default "/images/vendor/flag-icons/flags/1x1/hr.svg?dda03b1696e943679d3a187253a68325";